const BaseComponent = require( 'common/home/view' );
const Server = require( 'helper/server' );
const secuntry = require( 'helper/secuntry' );

const listTpl = Handlebars.templates[ 'common/home/templates/activity-list-item' ];

class Home extends BaseComponent {
  constructor() {
    super();
    Server.getActivityList( {
      homePageSearch: 1,
      pageSize: 2,
      pageNo: 1
    } ).then( ( { data } ) => {
      let _DATA_ = data && data.map( item => ( {
        ...item,
        activityTime: item.activityTime || '待定',
        shortBriefInfo: item.briefInfo.length > 83 ? item.briefInfo.slice( 0, 80 ) + '...' : item.briefInfo
      } ) );
      $( '#latestActivities .list' ).html( listTpl( { _DATA_ } ) );
      if (!data) {
        $( '#latestActivities .list' ).html( '<p class="noData">暂无数据</p>' );
      }
    }, () => {
      $( '#latestActivities .list' ).html( '<p class="noData">暂无数据</p>' );
    } );
    this.init();
  }

  init() {
    const date = new Date();
    const hour = date.getHours();
    let _t = '';
    if (hour <= 24 && hour > 17 || hour < 5) {
      _t = '晚上好，';
    } else if (hour < 12) {
      _t = '上午好，';
    } else if (hour <= 17) {
      _t = '下午好，';
    }
    this.$el.find( '.greetings .time' ).html( _t );
    this.captchaimg();
    this.initElegantBanner();

  }

  bindEvent() {
    super.bindEvent();
    this.$el.on( 'click.login', '.login', _.bind( this.login, this ) );
    this.$el.on( 'click.login', '.captchaimg', _.bind( this.captchaimg, this ) );
  }

  async login() {
    const memberName = this.$el.find( '#memberHome .username' ).val();
    const password = this.$el.find( '#memberHome .password' ).val();
    const captcha = this.$el.find( '#memberHome .captcha' ).val();
    const payload = {
      password: secuntry.encode( password ),
      memberName,
      captcha
    };
    // const spiner = this.$el.find( '.login-wrap' ).spin();
    try {
      const { success, result, error } = await Server.purchaseLogin( payload ) || {};
      // spiner.stop();
      if (success) {
        $( 'body' ).find( '.inner-container .loginedwrap .uername, .logined .greetings .name' ).text( result );
        $( 'body' ).find( '.logined, .loginedwrap' ).show();
        $( 'body' ).find( '.unlogin, .unloginwrap' ).hide();
        $( 'body' ).find( '.ZCY-comp-topline-v2 .submission' ).show();
        $( 'body' ).find( '.ZCY-comp-topline-v2 .message-center' ).show();
      } else {
        ZCY.utils.modal( {
          type: 'error',
          cls: 'as-modal',
          button: [ '确定' ],
          content: [ error ]

        } );
      }
    }
    catch ( e ) {
      alert( e.responseText || '未知错误' );
    }
  }

  captchaimg( e ) {
    const time = Date.now();
    let src = `/business/front/login/captcha?d=${ time }`;
    if (e) {
      const el = e.target || e.srcElement;
      $( el ).attr( 'src', src );
    } else {
      $( '.captchaimg' ).attr( 'src', src );
    }
  }

  initElegantBanner() {
    this.elegantBannerCount = 0;
    let timer = null;
    if (timer) {
      clearInterval( timer );
    }
    Server.purchaseHomeMembers().then( ( { data = [] } ) => {
      let html = '';
      $.map( data, ( item ) => {
        const { cover, memberName, id, orgName } = item;
        const img = cover ? `<img alt="${ orgName }-${ memberName }" src="${ cover }" />` : `<p data-v="${ orgName }-${ memberName }" class="noData">暂无图片</p>`;
        html += `<li class="memberPhotos_${ id }">
              <div class="img-wrap">
                ${ img }
              </div>
              <p>
                <span>${ orgName }</span>
              </p>
            </li>`;
      } );
      html += html;
      const memberPhotosWrap = this.$el.find( '.memberPhotos' );
      memberPhotosWrap.append( html );
      if (data.length < 5) {
        return false;
      }

      setInterval( () => {
        this.elegantBannerCount ++;
        this.elegantBannerMove( data.length );
      }, 3000 );
    } );
  }

  elegantBannerMove( size ) {
    const memberPhotos = this.$el.find( '.memberPhotos' );
    if (this.elegantBannerCount > size) {
      memberPhotos.css( {
        left: 0
      } );
      this.elegantBannerCount = 1;
    }
    memberPhotos.stop().animate(
      {
        left: - this.elegantBannerCount * 235
      },
      440
    );
  }
}

module.exports = Home;
